import React from 'react'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Scrollbar, A11y } from 'swiper'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
SwiperCore.use([Pagination, Scrollbar, A11y])
import { createResource, useResource } from '@/lib/i18n'
import { Animation, Reveal } from 'react-genie'
import Image from 'next/image'

const resource = createResource({
  en: {
    title: 'Kredit Pintar Features',
    title1: 'Loan Installment',
    title2: 'Borrow money instantly',
    title3: 'Low interests',
    title4: 'Safe and Reliable',
    title5: 'Customer service',
    title6: 'More benefits',
    desc1: 'Borrow money up to 50 Million Rupiahs mortgage-free',
    desc2: 'Instant loan application process with disbursement right to your bank account',
    desc3: 'Low interests loan for every needs',
    desc4: 'Protects all customer data & info. Registered & Supervised by OJK. ',
    desc5: 'Kredit Pintar Customer Service online during weekdays',
    desc6: 'Get installment discounts, vouchers, pulses, and much more!',
  },
  id: {
    title: 'Keuntungan di Kredit Pintar',
    title1: 'Pinjaman Cicilan',
    title2: 'Pinjam uang cepat',
    title3: 'Bunga Rendah',
    title4: 'Aman dan Terpercaya',
    title5: 'Customer service',
    title6: 'Keuntungan lain',
    desc1: 'Pinjam uang hingga 50 Juta Rupiah tanpa jaminan',
    desc2: 'Proses pengajuan pinjaman cepat cairnya ke rekening Anda. ',
    desc3: 'Pinjaman bunga rendah untuk berbagai kebutuhan',
    desc4: 'Data dan informasi pelanggan terlindungi. Terdaftar dan diawasi oleh OJK',
    desc5: 'Customer Service Kredit Pintar online selama hari kerja',
    desc6: 'Dapatkan diskon cicilan, voucher, pulsa, dan masih banyak lagi!',
  },
})

const Features = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  const FeatureList = [
    {
      img: '/images/home/icon_book.png',
      title: t('title1'),
      desc: t('desc1'),
    },
    {
      img: '/images/home/proses.png',
      title: t('title2'),
      desc: t('desc2'),
    },
    {
      img: '/images/home/bunga.png',
      title: t('title3'),
      desc: t('desc3'),
    },
    {
      img: '/images/home/aman.png',
      title: t('title4'),
      desc: t('desc4'),
    },
    {
      img: '/images/home/customer.png',
      title: t('title5'),
      desc: t('desc5'),
    },
    {
      img: '/images/home/keuntungan.png',
      title: t('title6'),
      desc: t('desc6'),
    },
  ]
  return (
    <FeatureStyle>
      <h2 className="title">{t('title')}</h2>
      <div className="items" style={{ width: width >= 1000 ? 'auto' : '360px' }}>
        {width >= 1000 ? (
          FeatureList.map((item, index) => (
            <Reveal key={index} delay={200 + index * 80} animation={Animation.FadeIn}>
              <div className="item">
                <div className="img">
                  <Image src={item.img} alt={item.title} width={40} height={40} quality={85} placeholder="empty" />
                </div>
                <div className="subtitle">{item.title}</div>
                <div className="des">{item.desc}</div>
              </div>
            </Reveal>
          ))
        ) : (
          <Swiper loop={true} pagination={{ clickable: true }}>
            {FeatureList.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="item">
                  <div className="img">
                    <Image src={item.img} alt={item.title} width={40} height={40} quality={85} placeholder="empty" />
                  </div>
                  <div className="subtitle">{item.title}</div>
                  <div className="des">{item.desc}</div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </FeatureStyle>
  )
}

export default Features

const FeatureStyle = styled.div`
  @media only screen and (max-width: 1000px) {
    margin: 64px auto 0;
    text-align: center;
    img {
      width: 100%;
      height: 100%;
    }
    .title {
      font-size: 24px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 28px;
      margin-bottom: 32px;
    }
    .items {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 0 auto;
      .item {
        width: 272px;
        height: 248px;
        margin: 0 auto;
        background: #ffffff;
        box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.03);
        border-radius: 8px;
        border: 1px solid #e6eaf0;
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        align-items: center;
        margin-bottom: 50px;
        .img {
          margin: 47px 0 15px 0;
          width: 40px;
          height: 40px;
        }
        .subtitle {
          font-size: 24px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #212121;
          line-height: 24px;
        }
        .des {
          margin-top: 14px;
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #9e9e9e;
          line-height: 24px;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    padding: 104px 150px 0px;
    text-align: center;
    max-width: 1440px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
    .title {
      font-size: 36px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 48px;
      margin-bottom: 48px;
    }
    .items {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item {
        width: 360px;
        height: 220px;
        background: #ffffff;
        box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.03);
        border-radius: 8px;
        border: 1px solid #e6eaf0;
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        align-items: center;
        margin-bottom: 32px;
        .img {
          margin: 47px 0 15px 0;
          width: 40px;
          height: 40px;
        }
        .subtitle {
          font-size: 24px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #212121;
          line-height: 24px;
        }
        .des {
          margin-top: 14px;
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #9e9e9e;
          line-height: 28px;
        }
      }
    }
  }
`
